// In-app admin navigation with extra query params (AdminPage listens to popstate).
export const goAdmin = (tab, params = {}) => {
  const qs = new URLSearchParams({ tab, ...params });
  window.history.pushState(null, '', `/admin?${qs}`);
  window.dispatchEvent(new PopStateEvent('popstate'));
};

export const adminHref = (tab, params = {}) => `/admin?${new URLSearchParams({ tab, ...params })}`;

// Read a one-time deep-link param and remove it from the URL.
export const takeAdminParam = (name) => {
  const params = new URLSearchParams(window.location.search);
  const v = params.get(name);
  if (v) {
    params.delete(name);
    window.history.replaceState(window.history.state, '', `${window.location.pathname}?${params}`);
  }
  return v;
};

export const onAdminLinkClick = (e, href) => {
  if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
  e.preventDefault();
  const u = new URL(href, window.location.origin);
  const { tab, ...rest } = Object.fromEntries(u.searchParams);
  goAdmin(tab, rest);
};
